export const outOfStockIngredients: string[] = [
  "JASMIN ORANGE",
  "FLORALE FRAICHE",
  "FLEUR DE JACINTHE",
];
